/**
 * Application-wide Enums and 'as const' maps
 */
export const ModCategory = {
  VR: 'vr',
  UEVR: 'uevr',
  HEAD_TRACKING: 'head-tracking',
} as const;
export type ModCategoryType = (typeof ModCategory)[keyof typeof ModCategory];

export const RequestStatus = {
  IDLE: 'IDLE',
  LOADING: 'LOADING',
  SUCCESS: 'SUCCESS',
  ERROR: 'ERROR',
} as const;
export type RequestStatusType = (typeof RequestStatus)[keyof typeof RequestStatus];

export const ComponentVariant = {
  PRIMARY: 'primary',
  SECONDARY: 'secondary',
  GHOST: 'ghost',
  OUTLINE: 'outline',
} as const;
export type ComponentVariantType = (typeof ComponentVariant)[keyof typeof ComponentVariant];

export const Language = {
  EN: 'en',
} as const;
export type LanguageType = (typeof Language)[keyof typeof Language];

export const LinkType = {
  INTERNAL: 'internal',
  EXTERNAL: 'external',
  WEB: 'web',
  GITHUB: 'github',
  COMMUNITY: 'community',
  DISCORD: 'discord',
  OTHER: 'other',
} as const;
export type LinkTypeValue = (typeof LinkType)[keyof typeof LinkType];

/**
 * Legacy/alternate spellings for `LinkType.INTERNAL` / `LinkType.EXTERNAL` that older
 * mod data may still use. Kept as named constants (rather than inline string literals)
 * so the two accepted spellings stay in sync everywhere they're checked.
 */
export const LEGACY_LINK_TYPE_ALIASES = {
  INTERNAL: 'interior',
  EXTERNAL: 'exterior',
} as const;

export const ModStatus = {
  PLAYABLE: 'Playable',
  WIP: 'WIP',
  COMING_SOON: 'Coming Soon',
} as const;
export type ModStatusType = (typeof ModStatus)[keyof typeof ModStatus];

export const ModSortBy = {
  UPDATED_AT: 'updatedAt',
  CREATED_AT: 'createdAt',
} as const;
export type ModSortByType = (typeof ModSortBy)[keyof typeof ModSortBy];

export const GameId = {
  SAIL_TO_UNKNOWN: 'sail-to-unknown',
} as const;
export type GameIdType = (typeof GameId)[keyof typeof GameId];

export const Developer = {
  SIMRLABS: 'SimrLabs',
} as const;
export type DeveloperType = (typeof Developer)[keyof typeof Developer];
